export class DropboxIsEntityAuthorizedRequest{
    public requestorId!:number;
    public customerId!:number;
    public clientIds:number[]=[];
}